import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { X } from 'lucide-react';
import { PRODUCTS, APPLICATIONS } from '../data/products';

const ALL_IMAGES = [
  ...PRODUCTS.flatMap((p) => [p.hero, ...p.gallery]),
  ...APPLICATIONS.map((a) => a.image),
];

// Distribute across 3 columns for pseudo-masonry
function columns(list, n) {
  const cols = Array.from({ length: n }, () => []);
  list.forEach((item, i) => cols[i % n].push(item));
  return cols;
}

export default function Gallery() {
  const [active, setActive] = useState(null);
  const cols = columns(ALL_IMAGES, 3);

  return (
    <main data-testid="gallery-page" className="bg-white text-[#111]">
      <Helmet>
        <title>Gallery | MODULAROOM</title>
        <meta name="description" content="An editorial gallery of MODULAROOM luxury modular homes, capsule suites and studio suites, photographed across resort, residential and commercial settings." />
        <link rel="canonical" href="https://modularoom.com/gallery" />
      </Helmet>
      <section className="pt-40 md:pt-52 pb-16 max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-[11px] tracking-[0.32em] uppercase text-black/50">Gallery</div>
        <h1 className="font-display text-5xl sm:text-6xl md:text-7xl mt-5 tracking-tight leading-[0.98] max-w-4xl">
          Moments in modular living.
        </h1>
      </section>

      <section className="pb-32 max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {cols.map((col, ci) => (
            <div key={`col-${ci}`} className="flex flex-col gap-4">
              {col.map((src, i) => (
                <button key={src} onClick={() => setActive(src)} data-testid={`gallery-tile-${ci}-${i}`} className="group relative w-full overflow-hidden rounded-2xl bg-[#F5F5F5]">
                  <img src={src} alt="MODULAROOM luxury modular home" className="w-full h-auto object-cover zoom-img" loading="lazy"/>
                </button>
              ))}
            </div>
          ))}
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-6" onClick={() => setActive(null)}>
          <button data-testid="gallery-close" className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setActive(null)}><X size={22}/></button>
          <img src={active} alt="preview" className="max-h-[92vh] max-w-[92vw] object-contain rounded-lg"/>
        </div>
      )}
    </main>
  );
}
